import styled from 'styled-components/macro'
import link from 'styles/mixins/link'

const LinkButton = styled.button.attrs({ type: 'button' })`
  background: none;
  border: none;
  cursor: pointer;
  display: inline;
  margin: 0;
  padding: 0;

  ${link()}

  &[disabled] {
    color: ${(props) => props.theme.colors.greyLight};
    cursor: default;
  }
`

export default LinkButton
